export const fields = {
  imperansCompany: {
    label: 'Imperans Company',
    rules: 'required',
  },
};
